import React from "react";
import { SearchBarElement } from "@components_common/components/utils";

const CustomSearchBar = (props) => {
  return (
    <SearchBarElement
      {...props}
      inputStyle={{ marginTop: "1em" }}
      placeholder="Search requests"
    />
  );
};

export default CustomSearchBar;
